<template>
  <!-- Event Categories -->
  <div class="flex flex-wrap justify-start gap-2 sm:gap-3 border-b border-secondary/40 border-dashed py-6">
    <AppButton
      v-if="categories.length > 0"
      :class="{'active': !searchParams.category}"
      class="btn-category"
      :disabled="!searchParams.category"
      @click="handleSearch"
    >
      All Photos
    </AppButton>

    <div
      v-for="category in categories"
      :key="category.id"
    >
      <AppButton
        :class="{ 'active': searchParams.category === category.id }"
        class="btn-category"
        :disabled="searchParams.category === category.id"
        @click="handleSearch(category)"
      >
        {{ category.name }}
      </AppButton>
    </div>
  </div>
</template>

<script setup>
import { AppButton } from '@/components/app';

import { useAuthStore } from '@/store';

const searchParams = defineModel('searchParams', { type: Object });
const protectedCategory = defineModel('protectedCategory', { type: Boolean });

const emit = defineEmits(['handleSearch']);

defineProps({
  categories: {
    type: Array,
    default: () => null,
  },
});

const authStore = useAuthStore();

const handleSearch = (category) => {
  if (category) {
    searchParams.value.category = category.id;
    protectedCategory.value = category.protected;

    // Verified users are able to see protected categories
    if (authStore.user?.isVerified) {
      protectedCategory.value = null;
    }
  } else {
    searchParams.value.category = null;
    protectedCategory.value = null;
  }
  emit('handleSearch', category);
};

</script>
